/*
 * Define constants here rather than hard-coding strings, so they are easy to find through
 * the code.
 */

// What clinic offerings do we use in Bedsider?
export const NavigateClinicOffering = {
  ABORTION_MAILING_PO_BOX: 'abortion_mailing_po_box',
  ABORTION_SERVICES: 'abortion_services',
  ABORTION_TELEHEALTH_PILL_DELIVERY: 'abortion_telehealth_pill_delivery',
  ABORTION_TELEHEALTH_PILL_PICKUP: 'abortion_telehealth_pill_pickup',
  ABORTION_TELEHEALTH_PILL_VISIT: 'abortion_telehealth_pill_visit',
  BIRTH_CONTROL: 'birth_control',
  EMERGENCY_CONTRACEPTION: 'emergency_contraception',
  IMPLANT_AVAILABLE: 'implant_available',
  IUD_AVAILABLE: 'iud_available',
  MEDICATION_ABORTION_PILL: 'medication_abortion_pill',
  STI_TESTING: 'sti_testing',
  SURGICAL_ABORTION: 'surgical_abortion',
}
